import React from 'react';
import { Tag, Button as AntButton, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined, FileTextOutlined, UndoOutlined } from '@ant-design/icons';
import { trangThaiPheDuyetValue } from '@app/utils/define';
import { BaseGatewayImage } from '@app/utils/apiUrl';


export const RenderApprovalBadge = ({ type, item }) => {
    // Một số bảng không qua phê duyệt (như Đào tạo / Ngoại ngữ)
    if (type === 'DaoTao' || type === 'NgoaiNgu') return null;

    const status = item.trangThaiPheDuyet;
    if (status === trangThaiPheDuyetValue.daPheDuyet) return <Tag color="success">Đã duyệt</Tag>;
    if (status === trangThaiPheDuyetValue.choPheDuyet) return <Tag color="warning">Chờ duyệt</Tag>;
    
    return (
        <div className="d-flex flex-column align-items-start gap-1">
            <Tag color="error">Từ chối</Tag>
            {item.lyDoTuChoi && (
                <div className="text-danger" style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>
                    Lý do: {item.lyDoTuChoi}
                </div>
            )}
        </div>
    );
};

export const RenderFileMinhChung = ({ jsonString }) => {
    if (!jsonString) return <span className="text-muted">Không có</span>;
    try {
        let files = [];
        const trimmed = typeof jsonString === 'string' ? jsonString.trim() : '';
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
            files = JSON.parse(jsonString);
        } else {
            files = [jsonString];
        }
        if (!Array.isArray(files) || files.length === 0) return <span className="text-muted">Không có</span>;
        return (
            <div className="d-flex flex-column gap-1">
                {files.map((url, idx) => {
                    if (!url) return null;
                    let fullUrl = url;
                    if (!url.startsWith("http://") && !url.startsWith("https://")) {
                        fullUrl = BaseGatewayImage + (url.startsWith("/") ? "" : "/") + url;
                    }
                    return (
                        <a key={idx} href={fullUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
                            <FileTextOutlined className="mr-1" /> Minh chứng {idx + 1}
                        </a>
                    );
                })}
            </div>
        );
    } catch (e) {
        let fullUrl = jsonString;
        if (typeof jsonString === 'string' && !jsonString.startsWith("http://") && !jsonString.startsWith("https://")) {
            fullUrl = BaseGatewayImage + (jsonString.startsWith("/") ? "" : "/") + jsonString;
        }
        return (
            <a href={fullUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
                <FileTextOutlined className="mr-1" /> Minh chứng
            </a>
        );
    }
};

export const RenderActionButtons = ({
    type,
    item,
    isAdmin,
    setSelectedItem,
    setActiveModal,
    handleDeleteItem,
    handleApprove,
    handleRevoke,
    openRejectModal
}) => {
    const isApproved = item.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet;
    const canEdit = !isApproved;

    return (
        <div className="d-flex gap-2">
            {/* Giảng viên Sửa/Xóa */}
            {canEdit && (
                <>
                    <AntButton
                        type="text"
                        icon={<EditOutlined style={{ color: '#1890ff' }} />}
                        onClick={() => {
                            setSelectedItem(item);
                            setActiveModal(type);
                        }}
                    />
                    <AntButton
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteItem(type, item.id)}
                    />
                </>
            )}

            {/* Admin Duyệt/Từ chối khi đang chờ duyệt */}
            {isAdmin && item.trangThaiPheDuyet === trangThaiPheDuyetValue.choPheDuyet && (
                <div className="border-left pl-2 ml-2 d-flex gap-1">
                    <Tooltip title="Duyệt bản ghi">
                        <AntButton
                            type="primary"
                            shape="circle"
                            size="small"
                            icon={<CheckOutlined />}
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                            onClick={() => handleApprove(type, item.id)}
                        />
                    </Tooltip>
                    <Tooltip title="Từ chối duyệt">
                        <AntButton
                            type="primary"
                            danger
                            shape="circle"
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() => openRejectModal(type, item.id)}
                        />
                    </Tooltip>
                </div>
            )}

            {/* Admin Thu hồi khi đã duyệt hoặc từ chối */}
            {isAdmin && (item.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet || item.trangThaiPheDuyet === trangThaiPheDuyetValue.tuChoi) && (
                <div className="border-left pl-2 ml-2">
                    <Tooltip title="Thu hồi (Chuyển về Chờ duyệt)">
                        <AntButton
                            type="default"
                            shape="round"
                            size="small"
                            icon={<UndoOutlined />}
                            style={{ 
                                fontSize: '11px',
                                minWidth: '95px'
                            }}
                            onClick={() => handleRevoke(type, item.id)}
                        >
                            Thu hồi
                        </AntButton>
                    </Tooltip>
                </div>
            )}
        </div>
    );
};
